import Vue from 'vue'
import app from './app.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import '@js/FontAwesomeLib'
import internationalization, { changeFavIcon } from '@js/libs/internationalization/internationalizations'
import { getCookie } from '@js/libs/cookie-handler'
import { VueI18nExtended, WhiteLabel } from '@js/interfaces'
// @ts-ignore
import config from '@/config'
import { preloadImages } from '@js/utils'

Vue.config.productionTip = false

// @ts-ignore
let {host, port} = process.env.NODE_ENV === 'development'
? config.development.microservice
: config.production.microservice

if(!host) host = `//${location.hostname}`
port = port ? `:${port}` : ''

const microserviceAddress = `${host}${port}`

const init = async () => {
  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: internationalization.defaultLocale,
    fallbackLocale: internationalization.defaultLocale,
    messages: internationalization.languages as VueI18n.LocaleMessages,
    whitelabel: {} as WhiteLabel,
    localeOverview: internationalization.localeOverview
  } as VueI18nExtended) as VueI18nExtended

  i18n.localeOverview = internationalization.localeOverview

  // Defines for whitelabel = brand
  const whitelabelCookieData = getCookie('wl')
  const whiteLabelName = whitelabelCookieData
  ? atob(whitelabelCookieData as string)
  : ''

  const url = `${microserviceAddress}/api/whitelabelbyname?whitelabel=${whiteLabelName}`
  const response = await fetch(url).catch(e => e)

  if(response && response.status === 200) {
    const whitelabel = await response.json()

    whitelabel.logoImg = microserviceAddress + whitelabel.logoImg
    whitelabel.favIcon = microserviceAddress + whitelabel.favIcon

    await preloadImages([whitelabel.logoImg, whitelabel.favIcon], 7000).catch(error => {
        // tslint:disable-next-line:no-console
        console.error(error)
        whitelabel.logoImg = ''
        whitelabel.favIcon = ''
      })

    changeFavIcon(whitelabel.favIcon)

    i18n.whitelabel = whitelabel
  } else {
    document.body.prepend('MSERR:521')
    // tslint:disable-next-line:no-console
    return console.error('MSERR:521')
  }

  const languageCookieData = getCookie('lang')
  languageCookieData
  ? i18n.locale = atob(languageCookieData as string)
  : i18n.locale = i18n.fallbackLocale

  // @ts-ignore
  window.app = new Vue({
    router,
    i18n,
    render: (h) => h(app)
  }).$mount('#app')
}

init()
